import { useQuery } from '@tanstack/react-query';

import {
  type TextContentContent,
  type TextContentContentFormat,
  TextContentContentSchema,
  type TextContentFilters,
  type TextContents,
  TextContentsSchema,
} from '@mai/types';

import { apiClient } from './axios';

import { logger } from '@utils/logger';

export const useTextContentsQuery = (
  params: TextContentFilters,
  enabled: boolean,
) => {
  return useQuery({
    queryKey: ['text-contents', params],
    queryFn: async () => {
      const response = await apiClient.get<TextContents>('/text-contents', {
        params,
      });
      const validatedData = TextContentsSchema.safeParse(response.data);
      if (!validatedData.success) {
        logger.warn('failed to validate text contents data', {
          error: validatedData.error,
        });
        return response.data;
      }
      return validatedData.data;
    },
    enabled,
  });
};

export const useTextContentContentQuery = (
  textContentId: string | null | undefined,
  format: TextContentContentFormat,
  enabled: boolean,
) => {
  return useQuery({
    queryKey: ['text-content-content', textContentId, format],
    queryFn: async () => {
      const response = await apiClient.get<TextContentContent>(
        `/text-contents/${textContentId}/content`,
        {
          params: { format },
        },
      );
      const validatedData = TextContentContentSchema.safeParse(response.data);
      if (!validatedData.success) {
        logger.warn('failed to validate text content content data', {
          error: validatedData.error,
        });
        return response.data;
      }
      return validatedData.data;
    },
    enabled,
  });
};
